import IndexPage from 'flarum/components/IndexPage'
import { extend, override } from 'flarum/extend';

import Application from 'flarum/Application'

import CustomFooter from './components/footer'

app.initializers.add('fstln/fstln-theme', () => {
  // extend(IndexPage.prototype,'viewItems',function(viewItems){
  //   viewItems.add('hahahaha')
  // })
  extend(Application.prototype, 'mount', () => {
    const footer = document.createElement('div')
    
    m.mount(document.body.appendChild(footer), CustomFooter)
  })

  // 处理全局gleam
  setTimeout(function () {
    var $gleam = document.querySelector('.as-gleam')
    if($gleam) {
      var s = document.createElement("script")
      s.type = "text/javascript"
      s.src = 'https://widget.gleamjs.io/e.js'
      $gleam.append(s)
    }
  }, 1000);
  (function () {
    var n = Math.random(0, 1)
    var origin = window.location.origin
    var link = document.createElement('link')
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.href = `${origin}/assets/vote.css?v=${n}`
    var head = document.getElementsByTagName('head')[0]
    head.appendChild(link)
  })()
});
